import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/assets";

const BRANDS = [
  {
    name: "Stage 3 Innovations",
    category: "Venture Studio",
    text: "A venture studio that builds, manages, and owns digital brands and businesses — creating enduring companies from the ground up.",
    image: IMAGES.stage3,
    domain: "stage3innovations.com",
  },
];

export default function Portfolio() {
  return (
    <div data-testid="portfolio-page">
      <PageHero
        testId="portfolio-hero"
        eyebrow="Portfolio"
        title={
          <>
            Brands we
            <br />
            build.
          </>
        }
        intro="Alongside our investments, we build and grow a family of enduring digital brands—purpose-driven businesses designed to improve lives, create lasting value, and serve people for decades to come."
        image={IMAGES.portfolioHero}
        alt="Architectural forms representing a portfolio of ventures at dusk"
      />

      <section className="bg-aveden-black py-20 lg:py-28">
        <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
          <div className="flex flex-col">
            {BRANDS.map((brand, i) => {
              const reversed = i % 2 === 1;
              return (
                <Reveal key={brand.name}>
                  <div
                    data-testid={`brand-${brand.name.toLowerCase()}`}
                    className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center py-14 lg:py-20 ${
                      i !== 0 ? "border-t border-white/[0.05]" : ""
                    }`}
                  >
                    <div
                      className={`relative aspect-[4/3] overflow-hidden ${
                        reversed ? "lg:order-2" : ""
                      }`}
                    >
                      <img
                        src={brand.image}
                        alt={brand.name}
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1600ms] ease-out hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className={reversed ? "lg:order-1" : ""}>
                      <p className="font-sans text-[11px] tracking-[0.32em] uppercase text-aveden-gold mb-5">
                        {brand.category}
                      </p>
                      <h3 className="font-serif font-light text-aveden-white text-4xl lg:text-5xl tracking-tight mb-6">
                        {brand.name}
                      </h3>
                      <div className="h-px w-12 bg-aveden-gold/60 mb-7" />
                      <p className="font-sans font-light text-aveden-gray text-base leading-relaxed max-w-md">
                        {brand.text}
                      </p>
                      <a
                        href={`https://${brand.domain}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`brand-domain-${brand.name.toLowerCase()}`}
                        className="group/link inline-flex items-center gap-2 mt-8 font-sans text-[13px] tracking-[0.12em] text-aveden-white hover:text-aveden-gold transition-colors duration-500"
                      >
                        {brand.domain}
                        <span className="h-px w-6 bg-aveden-gold transition-all duration-500 group-hover/link:w-10" />
                      </a>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
